import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const reasonForTripMachine =
  createTripArrayFieldMachine('reasonForTrip');
